import React, { useState } from "react";
import { BsChevronUp } from "@react-icons/all-files/bs/BsChevronUp";
import { BsChevronDown } from "@react-icons/all-files/bs/BsChevronDown";
import Heading, { HeadingLevel } from "../../Heading";
import {
  ProductBrandInterface,
  ProductCategoryInterface
} from "../../../interfaces/product";
import { productFilterStyles as styles } from "../styles";
import { ProductFilterType } from "../../../contexts/ProductFilterContext";
import ProductFilterButton from "./ProductFilterButton";

interface ProductFilterProps {
  headingLevel: HeadingLevel;
  title?: string;
  items: ProductCategoryInterface[] | ProductBrandInterface[];
  selected?: boolean;
  filterType: ProductFilterType;
}

const ProductFilter = ({
  headingLevel,
  title,
  items,
  filterType
}: ProductFilterProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      {title && (
        <Heading
          headingLevel={headingLevel}
          styles={styles.heading}
          onClick={() => setIsOpen(prev => !prev)}
        >
          {title} {isOpen ? <BsChevronUp /> : <BsChevronDown />}
        </Heading>
      )}
      <ul css={[styles.list, styles[`listOpen_${isOpen}`]]}>
        <li>
          <ProductFilterButton
            filterType={filterType}
            filter={{
              id: "ALL",
              title: "All"
            }}
          />
        </li>
        {items.map(item => (
          <li key={`filterButton_${filterType}_${item.id}`}>
            <ProductFilterButton filterType={filterType} filter={item} />
          </li>
        ))}
      </ul>
    </>
  );
};

export default ProductFilter;
